// @ts-strict-ignore
export class CompositeArticleInformation {
  public usageId: string;
  public articleId: number;
  public articleVersion: number;
  public articleNo: string;
  public originalPartUsageId: string;
  public groupId: string;

  public constructor(usageId: string, articleId: number, articleVersion: number, articleNo: string,
                     originalPartUsageId: string = null, groupId: string = null) {
    this.usageId = usageId;
    this.articleId = articleId;
    this.articleVersion = articleVersion;
    this.articleNo = articleNo;
    this.originalPartUsageId = originalPartUsageId;
    this.groupId = groupId;
  }
}
